import { html, css, LitElement } from 'lit-element';
import '@trumedianetworks/tmn-core-components/src/tmn-icon';
import '@github/clipboard-copy-element';

class CopyInput extends LitElement {
    constructor() {
        super();
    }
    static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex: 1;
                }
                clipboard-copy {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    --app-success-color: #00695c;
                    display: flex;
                }
                clipboard-copy > * {
                    margin: 4px;
                    cursor: pointer;
                }
                input {
                    display: flex;
                    flex: 1;
                    background: var(--light-gray-100);
                    padding: 4px;
                    border: 1px solid var(--light-gray-200);
                }
            `,
        ];
    }

    static get properties() {
        return {
            disabled: {
                type: Boolean,
            },
            value: {
                type: String,
            },
            copied: {
                type: Boolean,
            },
        };
    }

    updated(changedProps) {
        if (changedProps.has('value')) {
            this.copied = false;
        }
    }

    render() {
        const { value, copied } = this;

        return html`
            <clipboard-copy @clipboard-copy=${this.handleCopy} value=${value} for="blob-path">
                ${copied
                    ? html`<tmn-icon color="success" icon="done" iconvariant="outlined"></tmn-icon>`
                    : html`<tmn-icon icon="copy" iconvariant="outlined"></tmn-icon>`}
            </clipboard-copy>
            <input id="blob-path" class="token-input" value=${value} @blur=${this.handleBlur} />
        `;
    }

    handleBlur(e) {}

    handleCopy(e) {
        this.copied = true;
    }
}

window.customElements.define('copy-input', CopyInput);
